export default __webpack_public_path__ + "affb41c2bcde6d70c9b35befaf5988d5.svg";